import { Handle, Position } from "reactflow";
import { useState } from "react";
import Wizard from "./Wizard.js";
import {
  getSignificantFigures,
  getDecimal,
  getKeepTrailing,
  getDeleteMode,
  getDefaultEdgeInputConnectColour,
  getDefaultEdgeInputConnectColourHover,
  getDefaultEdgeOutputConnectColour,
  getDefaultEdgeOutputConnectColourHover,
  getNodeNamesOnly,
  getShowProbabilities,
  getProbabilitiesBlank,
  getUseSetStates,
  getShowBars,
  getBarsFillState,
} from "./UserSettings.js";
import { getEvidence } from "./Flow.js";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import "../css/custom-nodes.css";

function CustomNode({ data, id }) {
  const [isSource, setIsSource] = useState(false);

  const handleEdgeConnect = (edge) => {
    //TODO make is so you can connect an edge, then immediately click and drag to new node for new edge
    let targetDiv = document.getElementsByName(edge.target)[0];
    targetDiv.addEventListener('mouseover', MouseOverInput);
    targetDiv.addEventListener('mouseout', MouseOutInput);
    const mouseoutEvent = new Event('mouseout');
    targetDiv.dispatchEvent(mouseoutEvent);
    const mouseoverEvent = new Event('mouseover');
    targetDiv.dispatchEvent(mouseoverEvent);
  };

  function MouseOverInput(event) {
    const isLeftClick = event.buttons === 1;
    if (isLeftClick) {
      event.target.style.zIndex = 100;
      setIsSource(true);
    }
    for (let child of event.target.parentElement.children) {
      try {
        if (child.attributes.name.nodeValue.includes("react")) {
          child.style.background = getDefaultEdgeInputConnectColourHover();
        }
      } catch (error) { }
    }
    let parent = event.target.parentElement;
    while (parent) {
      if (parent.classList.contains('react-flow__node')) {
        parent.style.border = '1px solid red';
        break;
      }
      parent = parent.parentElement;
      if (!parent) {
        console.log('No parent element with class react-flow__node found.');
        break;
      }
    }
  }

  function MouseOutInput(event) {
    setIsSource(false);
    event.target.style.zIndex = 20;
    for (let child of event.target.parentElement.children) {
      try {
        if (child.attributes.name.nodeValue.includes("react")) {
          child.style.background = getDefaultEdgeInputConnectColour();
        }
      } catch (error) { }
    }
    let parent = event.target.parentElement;
    while (parent) {
      if (parent.classList.contains('react-flow__node')) {
        parent.style.border = '1px solid black';
        break;
      }
      parent = parent.parentElement;
      if (!parent) {
        console.log('No parent element with class react-flow__node found.');
        break;
      }
    }
  }

  function RemoveTrailingZeroes(num) {
    if (!getKeepTrailing()) {
      return num.toString().replace(/\.?0*$/, "");
    } else {
      return num.toString();
    }
  }

  function MaxStateBarGreen(state, data) {
    let blue = "#5db8ff";
    let green = "#49c549";
    // if Object.values(state)[0] is the max in data.states, return green, else, return blue
    let max = 0;
    for (let tempState of data.states) {
      if (Object.values(tempState)[0] > max) {
        max = Object.values(tempState)[0];
      }
    }
    if (Object.values(state)[0] === max) {
      return green;
    }
    return blue;
  }

  let cellBackgroundColor = "DimGray";
  const showAndFill = getShowBars() && getBarsFillState();
  const showAndNotFill = getShowBars() && !getBarsFillState();
  return (
    <div className="custom-node">
      <div>
        <div className={!isSource ? "sourceHandles" : "targetHandles"}>
          <Handle name="handle" position={Position.Bottom} type="source" style={{ display: 'none' }} />
          <Handle name="handle" position={Position.Bottom} type="target" style={{ display: 'none' }} />

          {/* <Handle
            type={!isSource ? "source" : "target"}
            name={isSource ? "reactSource" : "reactTarget"}
            position={Position.Top}
            style={{ background: getDefaultEdgeInputConnectColour() }}
          /> */}
          <Handle
            type={!isSource ? "source" : "target"}
            name={id}
            onMouseOver={MouseOverInput}
            onMouseOut={MouseOutInput}
            position={Position.Top}
            className="node-custom-handle node-custom-handle-position"
            onConnect={handleEdgeConnect}
          />
          {getDeleteMode() && data.states.length > 0 && (
            <div
              style={{
                position: "absolute",
                right: "-10px",
                top: "-10px",
                zIndex: "30",
              }}
            >
              <foreignObject>
                <body>
                  <Button
                    icon={
                      <DeleteOutlined
                        style={{ fontSize: "1.22em", paddingTop: "0.12em" }}
                      />
                    }
                    className="aaa"
                    size="small"
                    type="primary"
                    danger={true}
                    shape="square"
                    onClick={() => data.funcs.deleteNode(id)}
                  />
                </body>
              </foreignObject>
            </div>
          )}
        </div>
      </div>
      <div className="node-custom-content">
        <h2>{data.label}</h2>

        {!getNodeNamesOnly() && data.states.length > 0 && (
          <table class="cond-prob-table">
            <tr>
              <th>State</th>
              <th>P</th>
              {showAndNotFill && (
                <th>Bar</th>
              )}
            </tr>
            {data.states.map((state, i) => (
              <tr onClick={() => data.funcs.setEvi(i)}
                style={{
                  backgroundColor:
                    getEvidence(data.setStates) === i && getUseSetStates()
                      ? "#ffff4ca3"
                      : "white",
                }}
              >
                <td
                  style={{
                    backgroundImage: showAndFill ? `linear-gradient(to right, ${MaxStateBarGreen(state, data)} 0%, ${MaxStateBarGreen(state, data)} 100%)` : null,
                    backgroundRepeat: showAndFill ? "no-repeat" : null,
                    backgroundSize: showAndFill ? `${100 * Object.values(state)[0]}% 100%` : null,
                  }}>
                  <input
                    type={"button"}
                    value={Object.keys(state)[0]}
                    className="set-state"
                  />
                </td>
                <td style={{ backgroundColor: getShowProbabilities() ? "inherit" : cellBackgroundColor }}>
                  <text
                    style={{
                      color: getShowProbabilities() ? "black" : (!getProbabilitiesBlank() ? "#e2e2e2" : cellBackgroundColor)
                    }}
                  >
                    {Object.values(state)[0] != null
                      ? RemoveTrailingZeroes(
                        (
                          Object.values(state)[0] *
                          (1 + 99 * !getDecimal())
                        ).toFixed(
                          getSignificantFigures() < 2
                            ? getDecimal()
                              ? getSignificantFigures()
                              : 0
                            : getSignificantFigures() - 2 * !getDecimal()
                        )
                      ) + (getDecimal() ? "" : "%")
                      : Object.values(state)[0]}
                  </text>
                </td>
                {showAndNotFill && (
                  <td
                    style={{
                      backgroundImage: `linear-gradient(to right, ${MaxStateBarGreen(state, data)} 0%, ${MaxStateBarGreen(state, data)} 100%)`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: `${100 * Object.values(state)[0]}% 100%`,
                    }}
                  >
                  </td>
                )}
              </tr>
            ))}
          </table>
        )}
        <br></br>
        {!getNodeNamesOnly() &&
          data.condProb.length === data.states.length &&
          data.states.length === data.setStates.length && (
            <>
              <Wizard data={data} id={id} />
            </>
          )}

        {/* <div className="sourceHandles">
          <Handle name="reactSource" position={Position.Bottom} style={{ backgroundColor: getDefaultEdgeOutputConnectColour() }} />
          <Handle
            type="source"
            name="customSource"
            onMouseOver={MouseOverOutput}
            onMouseOut={MouseOutOutput}
            position={Position.Bottom}
            className="node-custom-handle node-custom-handle-source"

          />
        </div> */}
      </div>
    </div>
  );
}

export default CustomNode;
